import type { CSSProperties } from 'react';

const perceptionKeyframes = `
  @keyframes perceptionDraw {
    0% { stroke-dashoffset: 500; }
    50% { stroke-dashoffset: 0; }
    100% { stroke-dashoffset: -500; }
  }
  @keyframes perceptionPulse {
    0%, 100% { opacity: 0.6; stroke-width: 3.5; }
    50% { opacity: 1; stroke-width: 4; }
  }
`;

export type IconPerceptionProps = {
  animated?: boolean;
  height?: number | string;
  style?: CSSProperties;
  width?: number | string;
};

export const IconPerception = ({ animated = false, height = 23, style, width = 24 }: IconPerceptionProps) => (
  <>
    {animated ? <style>{perceptionKeyframes}</style> : null}
    <svg
      fill="none"
      height={height}
      style={{ filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.08))', ...style }}
      viewBox="0 0 84 37"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 27.9406C2 13.6655 9.24845 2.09375 18.1912 2.09375C27.1339 2.09375 34.3799 13.6654 34.3799 27.9404C34.3799 31.719 32.4621 34.7816 30.0944 34.7816C27.7267 34.7816 25.8088 31.7192 25.8088 27.9406C25.8088 13.6655 33.0573 2.09375 42 2.09375C50.9427 2.09375 58.1912 13.6656 58.1912 27.9406C58.1912 31.7192 56.2733 34.7816 53.9057 34.7816C51.538 34.7816 49.6177 31.6254 49.6177 27.8468C49.6177 13.5718 56.8661 2 65.8088 2C74.7516 2 82 13.5718 82 27.8468"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
        style={
          animated
            ? {
                animation: 'perceptionDraw 2.5s ease-in-out infinite, perceptionPulse 2.5s ease-in-out infinite',
                strokeDasharray: 500,
              }
            : undefined
        }
      />
    </svg>
  </>
);
